import React, { useEffect, useState } from 'react';
import {
	Dialog,
	IconButton,
	DialogTitle,
	DialogContent,
	makeStyles,
	DialogContentText,
	Box,
	Grid,
	Divider,
	lighten,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
// import HeadlineText from './HeadlineText';
// import AddUserForm from '../../forms/AddUserForm';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import {
	toggleFlightModal,
	toggleGSTModal,
	toggleTermModal,
} from '../../reducers/UiReducer';
import logodialog from '../../assets/images/logodialog.png';
import LoginForm from './LoginForm';
import spice from '../../assets/images/spice.gif';
import TitleText from './TitleText';
import BodyText from './BodyText';
import AddGSTForm from './AddGSTForm';
const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: 'transparent',
		backdropFilter: 'blur(2px)',
		'&MuiDialog-paperScrollPaper': {
			borderRadius: 5,
		},
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		// top: theme.spacing(3),
		padding: 0,
		[theme.breakpoints.down('xs')]: {
			top: theme.spacing(2.5),
		},
		color: theme.palette.grey[500],
	},
}));

const TermConditionModal = () => {
	const classes = useStyles();
	const theme = useTheme();
	const dispatch = useDispatch();
	const { search } = useSelector((state) => state.home);
	const { term } = useSelector((state) => state.ui);
	const [flight, setFlight] = useState(true);
	const [baggage, setBaggage] = useState(false);
	const [fare, setFare] = useState(false);
	const { createflight } = useSelector((state) => state.ui);
	const matches = useMediaQuery(theme.breakpoints.down('xs'));
	const handleClose = () => {
		dispatch(toggleTermModal(false));
	};
	function timeConvert(n) {
		var num = n;
		var hours = num / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ' hr and ' + rminutes + ' min.';
	}
	let appnt = [];
	// if (search) {
	// 	console.log('first');
	// 	search.data &&
	// 		search.data.Response &&
	// 		search.data.Response &&
	// 		search.data.Response.Results &&
	// 		search.data.Response.Results[0].map((app, index) => {
	// 			if (index === flightId) {
	// 				appnt.push({
	// 					...app,
	// 				});
	// 			}
	// 		});
	// }
	// useEffect(() => {
	// 	console.log('Hello Hi');
	// }, [createflight]);
	console.log('APPNT', appnt);
	return (
		<Dialog
			PaperProps={{
				style: { borderRadius: 10, maxWidth: 800 },
			}}
			TransitionProps={{
				style: { backgroundColor: 'transparent' },
			}}
			onClose={handleClose}
			aria-labelledby='customized-dialog-title'
			className={classes.root}
			open={term}>
			<DialogTitle id='customized-dialog-title' onClose={handleClose}>
				{/* <Box textAlign='center'> */}
				<Box display='flex' justifyContent='space-between'>
					<TitleText>Term & Condition</TitleText>
					<IconButton
						aria-label='close'
						className={classes.closeButton}
						onClick={handleClose}>
						<CloseIcon style={{ color: '#0035F0' }} fontSize='large' />
					</IconButton>
				</Box>
				<Divider />
				{/* </Box> */}
			</DialogTitle>
			<DialogContent>
				<Box>
					<li>
						Please make sure traveler(s) name and other details entered are
						exactly as on the passport (International)/ valid Id card
						(Domestic).
					</li>

					<li>
						In case of flight cancellation due to whatsoever reasons including
						cancellation of flight operation by the concerned airlines, refund
						of air ticket fare will be processed subject to “cancellation
						process charges” at the rate of Rs. 300/ and Rs. 500/ for domestic
						flight and international flight per person respectively. It may be
						noted the refund will be as per the airlines policy of cancellation,
						but it will be attracting “cancellation process charges” as stated
						herein above.
					</li>
					<li>
						All claims, disputes and litigation relating to online booking
						through this website anywhere from India or abroad shall be subject
						to jurisdiction of Courts of Delhi only.
					</li>
					<li>
						If you miss any flight then all subsequent onward journey flight/s
						ticket/s will get automatically canceled including your all return
						flight/s. There shall be no refund given by the airlines in such
						cases. Auto cancellation is done by airlines believing that person
						missing flight is not traveling and thus all onward journey flight/s
						ticket/s and return journey flight/s tickets must be made available
						to other potential passenger.
					</li>
					<li>
						We strongly recommend that you must visit official website of
						concern airlines to know terms of booking/ carriage and also
						official website of concerned country where you are visiting or
						transiting to know visa requirement.
					</li>
				</Box>
				<Box display='flex' mt={'10px'}>
					<button
						type='submit'
						disabled
						style={{
							cursor: 'pointer',
							padding: '14px 20px',
							backgroundColor: '#1593ff',
							color: 'white',
							marginLeft: 10,
							borderRadius: 5,
						}}>
						<TitleText two>Submit</TitleText>
					</button>
					<button
						type='submit'
						// disabled={isSubmitting}
						style={{
							cursor: 'pointer',
							padding: '8px 20px',
							backgroundColor: '#1593ff',
							color: 'white',
							marginLeft: 10,
							borderRadius: 5,
						}}>
						<TitleText two>Cancel</TitleText>
					</button>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default TermConditionModal;
